import { useState, useEffect, useRef } from "react";
import Image from "next/legacy/image";
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  SimpleGrid,
  Button,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import styles from "./ImageDrawer.module.css";
import SlideshowModal from "../SlideshowModal/SlideshowModal";
import { ChevronLeftIcon } from "@chakra-ui/icons";

interface ImageDrawerProps {
  elementId: number;
  saveAndShare: React.ReactNode;
  drawerClose: () => void;
  drawerOpen: boolean;
  images: string[];
}

const ImageDrawer = ({
  elementId,
  saveAndShare,
  drawerClose,
  drawerOpen,
  images,
}: ImageDrawerProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [activeImg, setActiveImg] = useState(0);

  const itemsRef = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    setTimeout(() => {
      if (itemsRef.current?.length > 0) {
        itemsRef.current[elementId].scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 1000);
  }, [itemsRef, elementId]);

  return (
    <Drawer
        onClose={drawerClose}
        isOpen={drawerOpen}
        isFullHeight={true}
        placement="bottom"
        blockScrollOnMount
      >
      <DrawerOverlay>
        <DrawerContent className={styles.drawer}>
          <DrawerHeader className={styles.header} pb={0}>
            <Flex justifyContent="space-between" alignItems="center" width="100%">
              <Button
                onClick={drawerClose}
                colorScheme="green"
                color="green.500"
                variant="ghost"
                aria-label="Go back"
                leftIcon={<ChevronLeftIcon />}
                size="sm"
              >
                Go back
              </Button>
              <Box>{saveAndShare}</Box>
            </Flex>
          </DrawerHeader>
          <DrawerBody pb="64px" className={styles.drawerBody}>
            <Flex justifyContent="center">
              <SimpleGrid columns={[1, null, 2]} spacing={2}>
                {images?.map((image: string, index: number) => {
                  if (typeof window !== "undefined") {
                    const imgDim = new (window as any).Image();
                    imgDim.src = image;
                    return (
                      <Flex
                          key={index}
                          justifyContent="center"
                          ref={el => {
                            (itemsRef.current[index] = el);
                          }}
                        >
                        <Image
                          src={imgDim.src}
                          className={styles.propertyImage}
                          width={500}
                          height={300}
                          onClick={() => {
                            onOpen();
                            setActiveImg(index);
                          }}
                          style={{
                            maxWidth: "100%",
                            height: "auto"
                          }} />
                      </Flex>
                    );
                  }
                })}
              </SimpleGrid>
            </Flex>
          </DrawerBody>
          <SlideshowModal
            images={images}
            modalOpen={isOpen}
            modalClose={onClose}
            imgId={activeImg}
          />
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default ImageDrawer;
